// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3597":"css/admin-app.7090","6576":"css/app.7090"}[chunkId] + ".css";
};